module.exports = __webpack_public_path__ + "img/banner1.59560198.jpg";